import React, { useEffect, useState, useRef } from 'react';
import Slider from 'react-slick'; 
import 'slick-carousel/slick/slick.css'; 
import 'slick-carousel/slick/slick-theme.css';
import '../pages/Yaamava.css'; 
import SearchBar from '../components/SearchBar/SearchBar';
import YaamavaNavBar from '../components/YaamavaNavBar/YaamavaNavBar';

/* <head>
  <meta charSet="utf-8" />
  <link rel="icon" href="%PUBLIC_URL%/picz/lakersOT/lakersfavicon.ico" />
  <meta name="viewport" content="width=device-width, initial-scale=1" />
  <meta name="theme-color" content="#000000" />
</head>
*/

/* ---------------------------
   🟣 Inline DiagonalImageReveal Component
--------------------------- */
function DiagonalImageReveal({ image1, image2 }) {
  const containerRef = useRef(null);
  const [reveal, setReveal] = useState(0.5); // Start at middle

  const handleMove = (e) => {
    const rect = containerRef.current.getBoundingClientRect();
    const x = e.clientX || (e.touches && e.touches[0].clientX);
    if (!x) return;
    const relX = (x - rect.left) / rect.width;
    setReveal(Math.min(1, Math.max(0, relX)));
  };

  return (
    <div
      ref={containerRef}
      className="reveal-container"
      onMouseMove={handleMove}
      onTouchMove={handleMove}
    >
      <img src={image1} alt="Left" className="reveal-image base" />
      <div
        className="reveal-overlay"
        style={{ width: `${reveal * 100}%` }}
      >
        <img src={image2} alt="Right" className="reveal-image top" />
      </div>
      <div
          className="reveal-divider"
          style={{ left: `${reveal * 100}%` }}
        >
          <div className="divider-handle" />
        </div>
    </div>
  );
}

/* ---------------------------
   🟣 Main Page Component
--------------------------- */
const Yaamava21 = () => {
  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    autoplay: true,
    autoplaySpeed: 3000,
    slidesToShow: 1,
    slidesToScroll: 1,
    adaptiveHeight: true,
  };
  
  useEffect(() => {
    document.body.style.backgroundSize = 'cover';
    return () => {
      document.body.style.background = '';
      document.body.style.backgroundSize = '';
    };
  }, []);

  /* ---------------------------
   🟣 Golf - Weather API & carousel
--------------------------- */
  useEffect(() => {
    // Inject weather widget script if not already present
    if (!document.getElementById('weatherwidget-io-js')) {
      const script = document.createElement('script');
      script.id = 'weatherwidget-io-js';
      script.src = 'https://weatherwidget.io/js/widget.min.js';
      script.async = true;
      document.body.appendChild(script);
    }
  }, []);

    return (
        <div>
          {/* Navbar */}
          <YaamavaNavBar />
    
          {/* Full-width Jumbotron */}
          <div className="jumbotron">
            {/* Slick Carousel */}
            <Slider {...settings} className="yaamava-carousel">

            {/* 🎥 First Slide — Vimeo Video */}
            <div
            className="carousel-item wpb_ym_banner wpb_ym_homepage_banner"
            >
            {/* Desktop Video */}
            <iframe
                src="https://player.vimeo.com/video/1096973965?share=copy&title=0&byline=0&portrait=0&background=1&autoplay=1&loop=1"
                frameBorder="0"
                allow="autoplay; fullscreen"
                title="Yaamava' Resort & Casino at San Manuel | Best Casino in California"
                className="wpb_ym_desktop-iframe"
            ></iframe>

            {/* Mobile Video (if needed) */}
            <iframe
                src="https://player.vimeo.com/video/1096973984?share=copy&title=0&byline=0&portrait=0&background=1&autoplay=1&loop=1"
                frameBorder="0"
                allow="autoplay; fullscreen"
                title="Yaamava' Resort & Casino at San Manuel | Best Casino in California"
                className="wpb_ym_mobile_iframe"
            ></iframe>


            </div>

              {/* 🏀 Existing Image Slides */}

              <div className="carousel-item lakerssliderimg">
                <img src="/picz/yaamava/monarch-beach-golf-links-min.jpg" alt="Lakers Russell" />
                <div className="carousel-caption" style={{ color: 'white' }}>
                  <i>"If you want white glove service and to be greeted at every corner, then you need to come to this amazing Yaamava’ Resort and Casino."
                    -Jennifer S, Google Reviews
                  </i>
                </div>
              </div>
              <div className="carousel-item lakerssliderimg">
                <img src="/picz/yaamava/palms-casino-resort-las-vegas-home-min-rev.jpg" alt="Lakers Brown Ingram" />
                <div className="carousel-caption" style={{ color: 'white' }}>
                  <i>Our resort rooms don’t just welcome you in, they pull you back. With luxe finishes, spa-like vibes, and total privacy, you might forget there’s a whole casino downstairs.</i>
                </div>
              </div>
            </Slider>
        
        {/* Awards */}
        <div className='awards'>
          <div className='serranoPlay'>
            <h2 style={{ fontFamily: 'Montserrat', color: '#3E4827', fontSize: '40px', fontWeight: '800', lineHeight: '1.2', paddingBottom: '1rem'}}>EXPERIENCE THE ENERGY FOR YOURSELF </h2>
              <h4>From luxurious accommodations to world-class performances, Yaamava’ Resort & Casino at San Manuel has cemented itself as the best casino in California and the only AAA Five-Diamond casino hotel in the country. Whether you’re a foodie fanatic, gaming pro, or frequent weekend tripper, you’ll easily find a reason to call Yaamava’ your home. With top-tier service and exceptional attention to detail, there’s nothing left to question, except this.</h4>
            <br />
              <div className='badges'>
                <img src="/picz/yaamava/2025_forbes_5s_white_0.svg" alt="you-in" style={{ width: '180px', padding: '0 20px', filter: "invert(1) grayscale(1)" }} />
                <img src="/picz/yaamava/PMS_AAA_5Diamond_Badge.svg" alt="you-in" style={{ width: '180px', padding: '0 20px'}} />
                <img src="/picz/yaamava/YR121324_CasinoOutsideVegas-1-1.svg" alt="you-in" style={{ width: '180px', padding: '0 20px'}} />
                <img src="/picz/yaamava/10Best2025_YaamavaOutsideVegas_1.svg" alt="you-in" style={{ width: '180px', padding: '0 20px'}} />
              </div>
            </div>
          </div>

        {/* SerranoClub Gold */}
        <div className='serranoClub' id="">
            <h2
              style={{
                textShadow: "0 0 6px #9FD35C, 0 0 4px #9FD35C, 0 0 2px #9FD35C",
                color: "#fff",
                fontSize: "3rem",
                textAlign: "center",
                textShadow: "0 6px 6px black",
              }}
            >
              VIP STARTS HERE
            </h2>
            <img src="/picz/yaamava/club-serrano-vertical_1.png" alt="serrano club" style={{ width: '50%' }} />
            <div className='serranoPlay'>
              <h4 style={{textShadow: "0 6px 6px black"}}>Play at Yaamava’, escape to Monarch Beach Golf Links, party at Palms Casino Resort. One program connects it all. Club Serrano puts more in your pocket, more on your plate, and more experiences at your fingertips.</h4>
            <br />
              <img src="/picz/yaamava/you-in-image.svg" alt="you-in" style={{ width: '50%'}} />
            </div>
          </div>
      </div>

      <div className='spacer'></div>

            {/* Ysocial */}
            <div className="btn-group2">
          <span className="btn btn-m">
            <a target="_blank" rel="noreferrer" href="https://facebook.com/yaamava"><img src="/picz/icons/facebook_icon.png" alt="Facebook Icon" style={{ width: '50%'}} /></a>
          </span>
          <span className="btn btn-m">
            <a target="_blank" rel="noreferrer" href="https://x.com/yaamava"><img src="/picz/icons/x__twitter_icon.png" alt="X-Twitter Icon" style={{ width: '50%', boxShadow: '0 0 5px white, 0 0 10px white'}} /></a>
          </span>
          <span className="btn btn-m">
            <a target="_blank" rel="noreferrer" href="https://www.instagram.com/yaamava">
            <img src="/picz/icons/instagram_icon.png" alt="Instagram Icon" style={{ width: '50%'}} /></a>
          </span>
          <span className="btn btn-m">
            <a target="_blank" rel="noreferrer" href="https://www.youtube.com/yaamava/">
            <img src="/picz/icons/iktok_icon.png" alt="TikTok Icon" style={{ width: '50%'}} /></a>
          </span>
        </div> 

        {/* Trifecta */}
        <div className='serranoClubLinks'>
          <div className="btn-group">
            <a
              target="_blank"
              rel="noreferrer"
              href="https://www.yaamava.com/casino"
              className="btn-image-link"
            >
              <img src="/picz/yaamava/yaamava-resort-and-casino-white_0.png" alt="casino" />
            </a>
            <a
              target="_blank"
              rel="noreferrer"
              href="https://www.palms.com/"
              className="btn-image-link"
            >
              <img src="/picz/yaamava/palms-casino-resort-white.png" alt="palms" />
            </a>
            <a
              target="_blank"
              rel="noreferrer"
              href="https://www.monarchbeachgolf.com/"
              className="btn-image-link"
            >
              <img src="/picz/yaamava/monarchlogo.svg" alt="monarch" />
            </a>
          </div>  
        </div>

      <div className='spacer'></div>

      {/* Giveaways */}
      <div
        id="Giveaways"
        className="relative flex flex-col items-center justify-center py-20 bg-gradient-to-b from-black via-gray-900 to-black text-white overflow-hidden"
      >
        <img
              src="/picz/yaamava/yaamava-resort-and-casino-white_0.png"
              alt="casino"
              className="carLogo"
              style={{filter:'invert(1) grayscale(1)', maxWidth: '40%'}}
            />
        <h2 className="text-4xl font-bold mb-8 z-10 tracking-wide text-center"  style={{
            textShadow: "0 0 6px #9FD35C, 0 0 4px #9FD35C, 0 0 2px #9FD35C",
            color: "#fff",
            fontSize: "3rem",
            textAlign: "center",
          }}>Giveaway Event
        </h2>
        <h3 className="text-3xl font-semibold mb-4">Win This Maserati Levante!</h3>

        {/* Car Image */}
        <div
          id="car-container"
          className="relative cursor-pointer perspective-1000 flex justify-center"
          onClick={() => {
            const car = document.getElementById('car-img');
            const text = document.getElementById('promo-text');

            // Remove any previous animation
            car.classList.remove('animate-drive-away');

            // Trigger animation
            void car.offsetWidth; // Force reflow to restart animation
            car.classList.add('animate-drive-away');

            // reset to center
            setTimeout(() => {
              car.classList.remove('animate-drive-away');
              car.style.transform = 'translateX(0) rotateY(0deg) scale(1)';
              car.style.opacity = '1';
              text.classList.remove('hidden');
            }, 2500);
          }}
        >
          <img
            id="car-img"
            src="/picz/yaamava/levante-maserati.png"
            alt="Maserati Levante Giveaway"
            className="transition-transform duration-500"
            style={{
              maxWidth: "500px",
              width: "100%",
              filter: "drop-shadow(0 0 20px rgba(255,255,255,0.6))"
            }}
          />
        </div>

        {/* Promotion Text */}
        <div
          id="promo-text"
          className="hidden text-center mt-10 max-w-xl animate-fade-in"
          style={{ color: 'rgba(255, 255, 255, 0.75)', 
          textShadow: '0 0 6px #9FD35C, 0 0 4px #9FD35C, 0 0 2px #9FD35C'}}
        >
          <p className="mb-3 text-lg">
            Feel the power and luxury — enter our exclusive giveaway and drive home this stunning Maserati Levante.
          </p>
          <p className="text-sm text-gray-300">
            *No purchase necessary. Open to residents 18+. Promotion ends Dec 31, 2025. See official rules for full details.
          </p>
        </div>

        {/* Animations */}
        <style>{`
          @keyframes driveAway {
            0% {
              transform: translateX(100vw) rotateY(0deg);
              opacity: 1;
            }
            20% {
              transform: translateX(0) rotateY(0deg);
              opacity: 1;
            }
            80% {
              transform: translateX(-100vw) rotateY(15deg) scale(0.9);
              opacity: 1;
            }
            100% {
              transform: translateX(-120vw) rotateY(15deg) scale(0.9);
              opacity: 0;
            }
          }

          .animate-drive-away {
            animation: driveAway 2.5s ease-in-out forwards;
          }

          @keyframes fadeIn {
            from { opacity: 0; transform: translateY(30px); }
            to { opacity: 1; transform: translateY(0); }
          }
          .animate-fade-in { animation: fadeIn 1s ease forwards; }

          .perspective-1000 { perspective: 1000px; }
        `}</style>
      </div>

        {/* Casino Section with Full-Width Image Reveal */}
        <div className="YsocialContainer">
          <section className="YsocialSection" id="Casino">
            <div className='serranoClubLinks'>
              <div className="btn-group">
              <h4 style={{ fontFamily: 'Montserrat', fontWeight: '800', color: '#bc9d4e', margin: '20px'}}>GHOSTBAR</h4>
                <a
                  target="_blank"
                  rel="noreferrer"
                  href="https://www.palms.com/"
                  className="btn-image-link"
                >
                  <img src="/picz/yaamava/palms-casino-resort-white.png" alt="palms" />
                </a>
                <h4 style={{ fontFamily: 'Montserrat', fontWeight: '900', color: '#bc9d4e', margin: '20px'}}>THE KINGPIN SUITE</h4>
            </div>
          </div>
              <DiagonalImageReveal
                image1="/picz/yaamava/Palms_Kingpin_Hero_v4.jpg"
                image2="/picz/yaamava/ghostbar.jpg"
              />
          </section>
        </div>


{/* Golf */}
<div className="MsocialContainer">
    <section className="MsocialSection" id="Golf">
        <div className='serranoClubLinks'>
            <div className="btn-group">
                <h4 style={{ fontFamily: 'Montserrat', fontWeight: '800', color: '#bc9d4e', margin: '20px'}}>Club Serrano Rewards</h4>
                <a
              target="_blank"
              rel="noreferrer"
              href="https://www.monarchbeachgolf.com/"
              className="btn-image-link"
            >
              <img src="/picz/yaamava/monarchlogo.svg" alt="monarch" />
            </a>
                <h4 style={{ fontFamily: 'Montserrat', fontWeight: '900', color: '#bc9d4e', margin: '20px', margin: '20px'}}>Book Tee Times</h4>
            </div>
        </div>
        <Slider {...settings} className="monarch-carousel">
            <div className="carousel-item lakerssliderimg">
                <img src="/picz/yaamava/DJI_0809.jpg" alt="Lakers Brown Ingram" />
                <div className="carousel-caption" style={{ color: 'white' }}>
                    <i>Our resort rooms don’t just welcome you in, they pull you back. With luxe finishes, spa-like vibes, and total privacy, you might forget there’s a whole casino downstairs.</i>
                </div>
            </div>
            <div className="carousel-item lakerssliderimg">
                <img src="/picz/yaamava/AJB9608.jpg" alt="Lakers Brown Ingram" />
                <div className="carousel-caption" style={{ color: 'white' }}>
                    <i>Our resort rooms don’t just welcome you in, they pull you back. With luxe finishes, spa-like vibes, and total privacy, you might forget there’s a whole casino downstairs.</i>
                </div>
            </div>
            <div className="carousel-item lakerssliderimg">
                <img src="/picz/yaamava/DSC0350-3.jpg" alt="Lakers Brown Ingram" />
                <div className="carousel-caption" style={{ color: 'white' }}>
                    <i>Our resort rooms don’t just welcome you in, they pull you back. With luxe finishes, spa-like vibes, and total privacy, you might forget there’s a whole casino downstairs.</i>
                </div>
            </div>
        </Slider>

        {/* Weather Widget */}
        <div className="weather-widget-container" style={{ textAlign: 'center', marginTop: '2rem' }}>
            <a
                className="weatherwidget-io"
                href="https://forecast7.com/en/33d47n117d70/dana-point/?unit=us"
                data-label_1="DANA POINT"
                data-label_2="WEATHER"
                data-font="Verdana"
                data-icons="Climacons Animated"
                data-theme="pure"
            >
                DANA POINT WEATHER
            </a>
        </div>
    </section>
</div>


    
      <div className='solid-line'></div>

      {/* Bottom header */}
      <section>
        <div className="subscribeBox" id="LakersSubscribe">
          <div className="container text-center">
            <h3>Get The Invite Before It’s Public</h3>
            <p><i>Insider Access to Promos, Concerts, and First-to-know Moments</i></p>
            <form className="subscribe-form">
              <div className="form-group">
                <label htmlFor="subscription">Full Name</label>
                <input
                  type="text"
                  className="form-control"
                  id="subscription"
                  placeholder="Your Name"
                />
              </div>
              <div className="form-group">
                <label htmlFor="email">Email Address</label>
                <input
                  type="text"
                  className="form-control"
                  id="email"
                  placeholder="Your Email"
                  name="Enter your Email"
                />
              </div>
              <div className="form-group">
                <button type="submit" className="btn-YSubscribe">Get Updates</button>
              </div>
            </form>
          </div>
        </div>
      </section>

      {/* Footer */}
      <div className="copyrightFooter">
        <div className="footerContainer">
          <div className="footerLeft">
            <img
              src="/picz/yaamava/yaamava-resort-and-casino-white_0.png"
              alt="casino"
            />
          </div>
          <div className="footerRight">
            <p>About Us</p>
            <p>Blog</p>
            <p>Yaamava Awards</p>
            <p>Privacy Policy</p>
          </div>
          <div className="footerAwards">
            <img src="/picz/yaamava/2025_forbes_5s_white_0.svg" alt="you-in" style={{ width: '100px', padding: '5px' }} />
            <img src="/picz/yaamava/PMS_AAA_5Diamond_Badge.svg" alt="you-in" style={{ width: '100px', padding: '5px'}} />
            <img src="/picz/yaamava/YR121324_CasinoOutsideVegas-1-1.svg" alt="you-in" style={{ width: '100px', padding: '5px'}} />
            <img src="/picz/yaamava/10Best2025_YaamavaOutsideVegas_1.svg" alt="you-in" style={{ width: '100px', padding: '5px'}} />
          </div>
        </div>
        <p className="footerCopyright">
          Copyright © 2025 Yaamava' Resort & Casino at San Manuel
        </p>
      </div>

    </div>
  );
};

export default Yaamava21;
